// extracted by mini-css-extract-plugin
export default {"container":"AuthCardContainer_container__en026","card-container":"AuthCardContainer_card-container__elTT2","logo":"AuthCardContainer_logo__OvYO5"};